// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * React hook module for fetching triage item counts.
 * Provides counts of items needing review and matched items.
 */
import { getTriageItemCounts } from '@/items/api/triage-get-counts';
import { useSuspenseQuery } from '@tanstack/react-query';

/**
 * React hook for fetching triage item counts by status.
 * Uses React Query's suspense mode for data fetching.
 *
 * @returns Object containing:
 * - needsReview: Count of items that need review
 * - matched: Count of items that have been matched
 * - Query status information (error, refetch, etc.)
 *
 * @throws Will suspend while loading data
 * @throws Will throw errors from the API if request fails
 */
export function useTriageItemCounts() {
  const { data, ...query } = useSuspenseQuery({
    queryKey: ['item-triage', 'counts'],
    queryFn: getTriageItemCounts,
  });

  return { ...data, ...query };
}
